// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.creative-form{
    display: flex;
    border: 1px solid #343A40 ;
    border-radius: 5px;
    padding: 10px 10px;
    position: relative;
    flex-direction: column;
}

.creative-form .submit{
    position: absolute;
    bottom: 5px;
    right: -5px;
}


.creative-form .options-container{
    display: flex;
    justify-content: space-between;
    width: 80%;
}

.optional-options .optional-options-container{
    display: flex;
    width: 100%;
    margin: 5px 0px;
    justify-content: space-between;
}


.other-container{
    margin: 0px 10px;
}

.call-to-action, .color{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.download-button{
    padding: 2px 3px;
    margin: 10px 10px;
    font-size: 15px;
    border: 1px solid black;
    border-radius: 5px;
}

.download-button:hover{
    cursor: pointer;
    background-color: #DEE2E6;
}

.list-container .single-list{
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
}


.size-select__control {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px; /* Reduce padding */
    box-shadow: none;
    transition: border-color 0.2s;
    min-height: 30px; /* Set a minimum height */
  }

  .tooltip-container {
    position: relative;
    display: inline-block;
  }
  
  .tooltip-text {
    visibility: hidden;
    width: 350px; /* adjust as needed */
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* adjust as needed */
    left: 50%;
    margin-left: -100px; /* adjust as needed */
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
  

  .channel-container span{
    color: red;
    font-size: 12px;
  }

  .options-container input[type='text']{
    width: 12vw;
  }

  .ad-container span{
    color: red;
    font-size: 12px;
    margin-right: 5px;    
  }

  .size-container span{
    color: red;
    font-size: 12px;
    margin-right: 5px;
  }

  .size-container{
    display: flex;
    flex-direction: column;
  }

  .size-container .size{
    display: flex;
  }

  .buttons{
    margin-right: 10px;
    display: flex;
    width: 150px;
    justify-content: space-around;
}

.buttons button{
    padding: 2px 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/creative.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY,EAAE,mBAAmB;IACjC,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY,EAAE,qBAAqB;IACnC,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,qBAAqB;IACnC,SAAS;IACT,mBAAmB,EAAE,qBAAqB;IAC1C,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;;EAGA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".creative-form{\n    display: flex;\n    border: 1px solid #343A40 ;\n    border-radius: 5px;\n    padding: 10px 10px;\n    position: relative;\n    flex-direction: column;\n}\n\n.creative-form .submit{\n    position: absolute;\n    bottom: 5px;\n    right: -5px;\n}\n\n\n.creative-form .options-container{\n    display: flex;\n    justify-content: space-between;\n    width: 80%;\n}\n\n.optional-options .optional-options-container{\n    display: flex;\n    width: 100%;\n    margin: 5px 0px;\n    justify-content: space-between;\n}\n\n\n.other-container{\n    margin: 0px 10px;\n}\n\n.call-to-action, .color{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.download-button{\n    padding: 2px 3px;\n    margin: 10px 10px;\n    font-size: 15px;\n    border: 1px solid black;\n    border-radius: 5px;\n}\n\n.download-button:hover{\n    cursor: pointer;\n    background-color: #DEE2E6;\n}\n\n.list-container .single-list{\n    margin: 10px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n\n\n.size-select__control {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 2px; /* Reduce padding */\n    box-shadow: none;\n    transition: border-color 0.2s;\n    min-height: 30px; /* Set a minimum height */\n  }\n\n  .tooltip-container {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .tooltip-text {\n    visibility: hidden;\n    width: 350px; /* adjust as needed */\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px 0;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%; /* adjust as needed */\n    left: 50%;\n    margin-left: -100px; /* adjust as needed */\n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n  \n  .tooltip-container:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n  }\n  \n\n  .channel-container span{\n    color: red;\n    font-size: 12px;\n  }\n\n  .options-container input[type='text']{\n    width: 12vw;\n  }\n\n  .ad-container span{\n    color: red;\n    font-size: 12px;\n    margin-right: 5px;    \n  }\n\n  .size-container span{\n    color: red;\n    font-size: 12px;\n    margin-right: 5px;\n  }\n\n  .size-container{\n    display: flex;\n    flex-direction: column;\n  }\n\n  .size-container .size{\n    display: flex;\n  }\n\n  .buttons{\n    margin-right: 10px;\n    display: flex;\n    width: 150px;\n    justify-content: space-around;\n}\n\n.buttons button{\n    padding: 2px 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
